import { useMemo, useState } from "react";
import { imgUrl } from "../../lib/api";
import { CATEGORY_LABELS } from "../../lib/site";
import { SectionHeading } from "./SectionHeading";
import { Lightbox } from "./Lightbox";

export const Gallery = ({ content, photos }) => {
  const [filter, setFilter] = useState("all");
  const [idx, setIdx] = useState(null);
  const cats = useMemo(() => [...new Set(photos.map((p) => p.category))], [photos]);
  const shown = filter === "all" ? photos : photos.filter((p) => p.category === filter);
  if (photos.length === 0) return null;

  return (
    <section id="galeria" data-testid="gallery-section" className="py-24 sm:py-32 bg-[#050505] border-y border-zinc-900">
      <div className="max-w-7xl mx-auto px-5 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8">
          <SectionHeading eyebrow="Ambientes" title={content.gallery_title} intro={content.gallery_intro} />
          {cats.length > 1 && (
            <div className="flex gap-2 overflow-x-auto pb-1 -mx-5 px-5 lg:mx-0 lg:px-0" role="tablist">
              {["all", ...cats].map((c) => (
                <button key={c} data-testid={`gallery-filter-${c}`} onClick={() => setFilter(c)} className={`shrink-0 px-4 py-2 rounded-full text-xs tracking-widest uppercase border transition-colors ${filter === c ? "bg-[#D4AF37] text-black border-[#D4AF37]" : "border-zinc-700 text-zinc-400 hover:border-[#D4AF37]/60"}`}>
                  {c === "all" ? "Todas" : CATEGORY_LABELS[c] || c}
                </button>
              ))}
            </div>
          )}
        </div>
        <div className="mt-14 columns-2 md:columns-3 gap-3 sm:gap-5 [&>*]:mb-3 sm:[&>*]:mb-5">
          {shown.map((p, i) => (
            <button key={p.id} data-testid={`gallery-item-${i}`} onClick={() => setIdx(i)} className="group relative block w-full overflow-hidden break-inside-avoid bg-[#111111]">
              <img src={imgUrl(p.thumb)} alt={p.title || "Foto do Vienna Palace Hotel"} loading="lazy" decoding="async" className="w-full h-auto transition-transform duration-700 group-hover:scale-105" />
              <span className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              {(p.title || p.caption) && !p.is_sample && (
                <span className="absolute left-4 bottom-4 text-left text-sm text-zinc-100 opacity-0 group-hover:opacity-100 transition-opacity duration-500">{p.title || p.caption}</span>
              )}
              {p.is_sample && <span className="absolute top-2 left-2 text-[9px] uppercase tracking-widest bg-black/60 px-2 py-1 text-zinc-300">Ilustrativa</span>}
            </button>
          ))}
        </div>
      </div>
      <Lightbox photos={shown} index={idx} onClose={() => setIdx(null)} onIndex={setIdx} />
    </section>
  );
};
